export default __webpack_public_path__ + "static/media/soja_r1.7139524e.png";